const getContextAwareUrlParams = params => {
  const keyValueArrays = Object.entries(params).map(([key, value]) =>
    typeof value === 'string' ? [key, value] : [key, 'NA'],
  );
  const entries = new Map(keyValueArrays);
  return Object.fromEntries(entries);
};

export default getContextAwareUrlParams;
